import React, { useEffect, useState } from 'react';

import Collapsible from 'react-collapsible';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { get } from 'lodash';

import Element from '../../components/element';
import Text from '../../components/text';
import NoData from '../../components/NoData';
import CancelAppointment from '../../components/CancelAppointment';
import Modal from '../../components/modal';
import useToast from '../../components/Toast/useToast';
import useStyles from './style';
import Flex from '../../components/flex';
import IconCalender from '../../assets/icons/IconCalender.svg';
import IconClock from '../../assets/icons/IconClock.svg';
import IconRescheduleAppointment from '../../assets/icons/IconRescheduleAppointment.svg';
import IconCancelAppointment from '../../assets/icons/IconCancelAppointment.svg';
import IconLocation from '../../assets/icons/IconLabLocation.svg';
import { ReactComponent as IconNoAppointments } from '../../assets/icons/IconNoAppointments.svg';
import { ReactComponent as IconDownArrow } from '../../assets/icons/IconDownArrow.svg';
import { ReactComponent as IconUpArrow } from '../../assets/icons/IconUpArrow.svg';
import { colors } from '../../config/theme';
import { GET_UPCOMING_APPOINTMENTS, GET_LOCATIONS } from '../../api/endpoints';
import { apiRequest } from '../../api/actions';
import { getTimeWithAmOrPm } from '../../utils';

const getUser = state => {
  return state.containers.app.get('user');
};

const ViewAppointment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(getUser);
  const classes = useStyles();
  const [openSnackbar] = useToast();

  const [upcomingAppointments, setUpcomingAppointments] = useState([]);
  const [mapOpenClose, setMapOpenClose] = useState({ '1': false, '2': false });
  const [showDeactivateConfirmModal, setShowDeactivateConfirmModal] = useState(
    false
  );
  const [cancellationFee, setCancellationFee] = useState();
  const onClickReSchedule = appointmentDetail => {
    navigate('/landing/appointment/schedule', {
      replace: true,
      state: { appointmentDetail }
    });
  };
  const toggleActivateDeactivateModal = () => {
    setShowDeactivateConfirmModal(!showDeactivateConfirmModal);
  };

  const onClickScheduleAppointment = () => {
    navigate('/landing/appointment/schedule');
  };

  const cancelAppointmentPatient = () => {
    const visitId = get(upcomingAppointments[0], '_id');
    const request = {
      method: 'put',
      url: `me/visit/${visitId}/cancel`,
      data: { reason: 'reason for cancel' }
    };
    const meta = {
      onSuccess: res => {
        if (res.data.error?.code) {
          openSnackbar(res.data.message, 'warn');
          return;
        }
        setShowDeactivateConfirmModal(false);
        openSnackbar('Your appointment has been cancelled.');
        setUpcomingAppointments([]);
      }
    };
    dispatch(apiRequest(request, meta));
  };

  useEffect(() => {
    const request = {
      method: 'get',
      url: GET_LOCATIONS
    };
    const meta = {
      onSuccess: data => {
        if (data.data.error?.code) {
          openSnackbar(data.data.message, 'warn');
          return;
        }
        const locations = data?.data?.data;

        const cancelFee = locations.filter(
          location =>
            location._id === get(upcomingAppointments[0], 'clinic._id')
        )[0]?.cancellationFee;
        setCancellationFee(cancelFee);
      }
    };

    dispatch(apiRequest(request, meta));
  }, [upcomingAppointments]);

  useEffect(() => {
    const request = {
      method: 'post',
      url: GET_UPCOMING_APPOINTMENTS,
      data: {
        id: user?.id
      }
    };
    const meta = {
      onSuccess: data => {
        if (data.data.error?.code) {
          openSnackbar(data.data.message, 'warn');
          return;
        }
        setUpcomingAppointments(data.data.data);
      }
    };

    dispatch(apiRequest(request, meta));
  }, [user]);

  return (
    <Element>
      {upcomingAppointments.length ? (
        <>
          <Flex justify="space-between">
            <Text type="h4" size="21px">
              Upcoming Appointment Details
            </Text>
            <Flex align="center" marginRight="14px">
              <Element marginRight="30px">
                <Flex
                  align="center"
                  cursor="pointer"
                  onClick={() => onClickReSchedule(upcomingAppointments[0])}
                >
                  <Element
                    type="img"
                    attrs={{ src: IconRescheduleAppointment }}
                    marginRight="8px"
                  />
                  <Text
                    type="h5"
                    family="GTAM"
                    size="16px"
                    color={colors.dustyGray}
                  >
                    Reschedule
                  </Text>
                </Flex>
              </Element>
              <Element onClick={toggleActivateDeactivateModal}>
                <Flex align="center" cursor="pointer">
                  <Element
                    type="img"
                    attrs={{ src: IconCancelAppointment }}
                    marginRight="8px"
                  />
                  <Text
                    type="h5"
                    family="GTAM"
                    size="16px"
                    color={colors.dustyGray}
                  >
                    Cancel
                  </Text>
                </Flex>
              </Element>
            </Flex>
          </Flex>
          {upcomingAppointments.map(appointment => (
            <Flex
              style={{
                padding: '40px 30px',
                border: `1px solid ${colors.lightGray}`,
                borderRadius: '4px',
                marginTop: '15px'
              }}
            >
              <Element width="50%">
                <Text type="h5" family="GTAM" size="16px">
                  Date & Time
                </Text>
                <Flex align="center" marginBottom="50px">
                  <Element
                    type="img"
                    attrs={{ src: IconCalender }}
                    marginRight="8px"
                  />
                  <Text type="h5" size="16px">
                    {`${moment(appointment.visitDate).format('LL')}`}
                  </Text>
                  <Text type="h5" size="16px" margin="0 16px">
                    at
                  </Text>
                  <Element
                    type="img"
                    attrs={{ src: IconClock }}
                    marginRight="8px"
                  />
                  <Text type="h5" size="16px">
                    {`${getTimeWithAmOrPm(appointment.scheduledTime)}`}
                  </Text>
                </Flex>
              </Element>
              <Element width="50%">
                <Text type="h5" family="GTAM" size="16px">
                  Location
                </Text>
                <Flex align="start">
                  <Element
                    type="img"
                    attrs={{ src: IconLocation }}
                    marginRight="15px"
                    marginTop="10px"
                    width="24px"
                    height="24px"
                  />
                  <Element>
                    <Text type="h5" size="16px">
                      {appointment.clinic.name}
                    </Text>
                    <Text type="h5" size="16px">
                      {`${appointment.clinic.address}, ${appointment.clinic.address1}`}
                    </Text>
                    <Text type="h5" size="16px">
                      {`${appointment.clinic.city}, ${appointment.clinic.state.name}, ${appointment.clinic.zipcode}`}
                    </Text>
                  </Element>
                </Flex>
              </Element>
            </Flex>
          ))}
          <Text marginTop="35px" family="GTAM" color={colors.dustyGray}>
            Here’s some helpful info about what to expect from your visit.
          </Text>
          <Element
            marginTop="24px"
            borderTop={`1px solid ${colors.lighterGray}`}
          >
            <Collapsible
              trigger={
                <>
                  <Text type="h4" size="21px">
                    What to Expect
                  </Text>
                  <Element
                    type={mapOpenClose['1'] ? IconUpArrow : IconDownArrow}
                    width="24px"
                    height="24px"
                    position="absolute"
                    right="5px"
                    top={mapOpenClose['1'] ? '18%' : '40%'}
                  />
                </>
              }
              onOpen={() => setMapOpenClose({ ...mapOpenClose, '1': true })}
              onClose={() => setMapOpenClose({ ...mapOpenClose, '1': false })}
              className={`${classes.collapse} ${classes.close}`}
              openedClassName={`${classes.collapse}  ${classes.close}`}
            >
              <p className={classes.collapseContent}>
                The entire visit will last up to{' '}
                {upcomingAppointments[0].clinic.appointmentDurationInMinutes}{' '}
                minutes. We will measure your vital signs and perform a standard
                blood draw (fasting is not required). We will also perform a 3D
                body surface scan, body composition analysis, cognitive battery,
                as well as assessments of strength, dexterity, and balance. We
                will explain these tests to you as we go, and we will discuss
                all of your results with you at the end of your visit.
              </p>
            </Collapsible>
            <Collapsible
              trigger={
                <>
                  <Text type="h4" size="21px">
                    Contact us
                  </Text>
                  <Element
                    type={mapOpenClose['2'] ? IconUpArrow : IconDownArrow}
                    width="24px"
                    height="24px"
                    position="absolute"
                    right="5px"
                    top={mapOpenClose['2'] ? '18%' : '40%'}
                  />
                </>
              }
              onOpen={() => setMapOpenClose({ ...mapOpenClose, '2': true })}
              onClose={() => setMapOpenClose({ ...mapOpenClose, '2': false })}
              className={`${classes.collapse} ${classes.close}`}
              openedClassName={`${classes.collapse}  ${classes.close}`}
            >
              <p className={classes.collapseContent}>
                We are here to answer any questions that may arise as you
                prepare for your visit. Please feel free to contact us. <br />
                <br />
                Email: thornelabs4help@thorne.com
                {/*upcomingAppointments[0].clinic.email*/}
              </p>
            </Collapsible>
          </Element>
        </>
      ) : (
        <NoData
          icon={IconNoAppointments}
          msg="You have no scheduled appointments at this time."
          btnTitle="Schedule Appointment"
          btnClickCallBack={onClickScheduleAppointment}
        />
      )}
      {showDeactivateConfirmModal && (
        <Modal
          headerLabel="Cancel Appointment"
          closable={true}
          onClose={() => setShowDeactivateConfirmModal(false)}
          width="608px"
          height={cancellationFee !== 0 ? '347px' : '300px'}
        >
          <CancelAppointment
            onClose={() => setShowDeactivateConfirmModal(false)}
            // onConfirm={onDeactivateConfirm}
            question="Are you sure you want to cancel your appointment?"
            desc={
              cancellationFee !== 0 && (
                <Text
                  family="GTAM"
                  type="h5"
                  size="16px"
                  marginTop="24px"
                  color={colors.ceriseRed}
                >
                  Note that a ${cancellationFee} fee will automatically be
                  charged to your credit card for canceling an appointment less
                  than 24 hours prior to the scheduled date & time.
                </Text>
              )
            }
            confirmText="Confirm Cancellation"
            onReschedule={() => onClickReSchedule(upcomingAppointments[0])}
            onCancel={cancelAppointmentPatient}
            reschedule
          />
        </Modal>
      )}
    </Element>
  );
};

export default ViewAppointment;
